// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1bxAz","footer":"Form_footer__2cuad"};